export const DEFAULT_PARAMETER_BAR_CLOSE_TO_LIMIT_THRESHOLD = 0.1;
